import { en } from "@inkline/inkline/i18n/messages";
export * from "@inkline/inkline/i18n/translate";
export const i18n = {
  locale: "en",
  messages: {
    en
  }
};
export function setLocale(locale) {
  i18n.locale = locale;
}
